import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Custom cart drawer that:
 * - Locks page scroll behind it
 * - Keeps full height
 * - Allows scrolling inside cart items
 * - Keeps summary sticky
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    // Lock body scroll when drawer opens
    this.addEventListener('dialog:open', () => {
      document.body.style.overflow = 'hidden';
      this.#setFullHeight();
    });

    // Unlock body scroll when drawer closes
    this.addEventListener('dialog:close', () => {
      document.body.style.overflow = '';
    });

    // Resize observer for window resizing
    window.addEventListener('resize', this.#setFullHeight);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    window.removeEventListener('resize', this.#setFullHeight);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  // Sets drawer inner to full viewport height
  #setFullHeight = () => {
    const dialog = this.querySelector('.cart-drawer__dialog');
    const inner = this.querySelector('.cart-drawer__inner');
    if (dialog && inner) {
      const vh = window.innerHeight;
      dialog.style.height = `${vh}px`;
      inner.style.height = `${vh}px`;
    }
  };

  open() {
    this.showDialog();

    // Close drawer when installments CTA is clicked
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}